import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageHeader from 'componentes/common/PageHeader.js';
import SubtleBadge from 'componentes/common/SubtleBadge.js';
import React, { useEffect, useState } from 'react';
import { ApiEndpoint, getParameterById } from 'helpers/ApiEndPoint.js';
import { useAuth } from 'context/AuthProvider.js';
import { httpClient } from 'helpers/HttpClient.js';
import { Card, Col, Row } from 'react-bootstrap';
import AddressTable from './_AddressTable.js';
import SubCustomersTable from './_SubCustomersTable.js';
import DeterminantesTable from './_DeterminantesTable.js';
import MyModal from 'helpers/MyModal.js';
import EditAdress from './_EditAdress.js';
import EditSubcustomer from './_EditSubcustomer.js';
import EditDeterminante from './_EditDeterminante.js';
const URI = ApiEndpoint + 'administration/';

const DetailCustomer = () => {
  const idCustomer = getParameterById('idcustomer');
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [customer, setCustomer] = useState(null);
  const [openModalDeterminante, setOpenModalDeterminante] = useState(null);
  const [openModalAddress, setOpenModalAddress] = useState(null);
  const [openModalSubcustomer, setOpenModalSubcustomer] = useState(null);
  const [idAddressEdit, setIdAddressEdit] = useState(null);
  const [idSubCustomerEdit, setIdSubCustomerEdit] = useState(null);
  const [idDeterminanteEdit, setIdDeterminanteEdit] = useState(null);
  const [addreses, setAdreses] = useState([]);
  const [subcustomers, setSubCustomers] = useState([]);
  const [determinantesCustomer, setDeterminantesCustomer] = useState([]);
  const handleCloseAddress = () => {
    setOpenModalAddress(false);
    getCustomerAdreses();
  };
  const handleCloseDeterminante = () => {
    setOpenModalDeterminante(false);
    getDeterminantes();
  };
  const handleCloseCustomer = () => {
    setOpenModalSubcustomer(false);
    getSubCustomers();
  };
  const getCustomer = async () => {
    setCustomer(null);

    httpClient('GET', URI + 'customers/' + idCustomer, {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setCustomer(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  const getCustomerAdreses = async () => {
    setAdreses(null);

    httpClient(
      'GET',
      URI + 'customersaddress/' + idCustomer,
      {},
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          setAdreses(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  const getSubCustomers = async () => {
    setSubCustomers(null);

    httpClient('GET', URI + 'subcustomers/' + idCustomer, {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setSubCustomers(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  const getDeterminantes = async () => {
    setDeterminantesCustomer(null);

    httpClient(
      'GET',
      URI + 'customerdeterminantes/' + idCustomer,
      {},
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          setDeterminantesCustomer(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    getCustomerAdreses();
    getCustomer();
    getSubCustomers();
    getDeterminantes();
  }, []);
  return (
    <>
      {customer && (
        <>
          <PageHeader
            title={'Cliente: ' + customer.clave}
            titleTag="h5"
            className="mb-3"
          >
            <p className="fs-10 mt-1">{customer.razonsocial}</p>
            <div>
              <strong className="me-2">Status: </strong>
              <SubtleBadge pill bg="success" className="fs-11">
                {customer.status.descripcion}
                <FontAwesomeIcon
                  icon="check"
                  className="ms-1"
                  transform="shrink-2"
                />
              </SubtleBadge>
            </div>
          </PageHeader>
          <Card className="mb-3">
            <Card.Body>
              <Row>
                <Col>
                  {addreses && (
                    <AddressTable
                      addreses={addreses}
                      setIdAddressEdit={setIdAddressEdit}
                      setOpenModal={setOpenModalAddress}
                    ></AddressTable>
                  )}
                </Col>
                <Col>
                  {subcustomers && (
                    <SubCustomersTable
                      subcustomers={subcustomers}
                      setIdSubCustomerEdit={setIdSubCustomerEdit}
                      setOpenModalSubcustomer={setOpenModalSubcustomer}
                    ></SubCustomersTable>
                  )}
                </Col>
              </Row>
              <Row>
                <Col>
                  {determinantesCustomer && (
                    <DeterminantesTable
                      determinantes={determinantesCustomer}
                      setIdDeterminanteEdit={setIdDeterminanteEdit}
                      setOpenModal={setOpenModalDeterminante}
                    ></DeterminantesTable>
                  )}
                </Col>
              </Row>
            </Card.Body>
          </Card>{' '}
          {openModalAddress && (
            <MyModal
              id="id_myModal"
              title={(idAddressEdit > 0 ? 'Editar' : 'Agregar') + '  Direccion'}
              openModal={openModalAddress}
              closeModal={handleCloseAddress}
            >
              <EditAdress
                idAddress={idAddressEdit}
                idCustomer={idCustomer}
                closeModal={handleCloseAddress}
              ></EditAdress>
            </MyModal>
          )}{' '}
          {openModalSubcustomer && (
            <MyModal
              id="id_myModal"
              title={
                (idSubCustomerEdit > 0 ? 'Editar' : 'Agregar') + '  SubCliente'
              }
              openModal={openModalSubcustomer}
              closeModal={handleCloseCustomer}
            >
              <EditSubcustomer
                idSubcustomer={idSubCustomerEdit}
                idCustomer={idCustomer}
                closeModal={handleCloseCustomer}
              ></EditSubcustomer>
            </MyModal>
          )}{' '}
          {openModalDeterminante && (
            <MyModal
              id="id_myModal"
              title={
                (idDeterminanteEdit > 0 ? 'Editar' : 'Agregar') +
                '  Determinante'
              }
              openModal={openModalDeterminante}
              closeModal={handleCloseDeterminante}
            >
              <EditDeterminante
                idDeterminante={idDeterminanteEdit}
                idCustomer={idCustomer}
                closeModal={handleCloseDeterminante}
              ></EditDeterminante>
            </MyModal>
          )}
        </>
      )}
    </>
  );
};

export default DetailCustomer;
